<template>
  <div class="learnmaterials">

    <headerview :cur="4"></headerview>

    <div class="content">

      <div class="moddlecon w13 min-h">
        <div class="tipcon">
          <tipcon :title="'学习资料'" :name="'学习资料'" :imgtype="'2'" width="2.12"></tipcon>
        </div>

        <div class="carcon">
          <div class="l_c">
            <div class="frame">
              <div v-for="(items,index) in tablist" :key="index">
                <div class="signle" @click="changetab(index)">
                  <img v-show="tabindex != index" class="imga" src="../../../static/img/mininav@2x.png" alt=""/>
                  <img v-show="tabindex == index " class="imga" src="../../../static/img/mininav_cur@2x.png" alt=""/>
                  <span :class="tabindex == index?'text_cur':'text'">{{items.name||''}}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="r_c" v-if='!isDetail'>
              <div class="listbox">
                <div class="signle f-row-b" v-for="(item,index) in tablist[tabindex].list" :key="index" @click="changesontab(index)">
                  <div class="label overfh" :title="item.compilationTitle||''">{{item.compilationTitle||''}}</div>
                  <div class="time">{{item.createTime.split(' ')[0] || ''}}</div>
                </div>
              </div>

              <!-- 分页 -->
              <div>
                <div v-if='pageTip' is='footPage' class="zhini-pagination"
                  :currentPage="pageNo"
                  :totalPage="total?total:0"
                  ref="foot"
                  @pageNum="pageNum"  :pagesize='pageSize'></div>
              </div>
          </div>
          <!-- 详情 -->
          <div class="r_c" v-if='isDetail'>
            <!-- <div class="shareto">
              分享至:
              <img class="imgwc" src="../../../static/img/wechat@2x.png" alt=""/>
              <img class="imgqq" src="../../../static/img/qq@2x.png" alt="" @click="qqshare"/>
            </div> -->

            <div class="title">{{ informdata.compilationTitle || '' }}</div>
            <div class="timesource">
              {{ informdata.publishTime || '' }}
              <span style="margin-left: 20px;" v-if='informdata.source'>
								来源: {{ informdata.source || '' }}
							</span>
            </div>
            <div class="line"></div>
            <div class="pic_box" v-if="informdata.fileId">
              <img class="pic" :src="this.$fileAccessHttpUrl(informdata.fileId_dictText)" alt="">
            </div>

            <div class="msg" v-html="informdata.compilationContent||''"></div>
            <div v-if='smallFile.length>0'>
              <div v-for="(item,ind) in smallFile" :key='ind' class="click-a">
                <div @click="openUrl(item.src)">{{item.txt}}</div>
              </div>
            </div>
            <div v-if='bigFile.length>0'>
              <div v-for="(item,ind) in bigFile" :key='ind' class="click-a">
                <div @click="openUrl(item.src)">{{item.txt}}</div>
              </div>
            </div>
            
            <!-- <el-button v-if="informdata.thumbnail||informdata.uploadType==1" type="primary" class="download" @click="downLoadfile(informdata)">附件下载<i
                class="el-icon-download el-icon--right"></i></el-button> -->
          </div>

        </div>

      </div>

    </div>

    <footview></footview>

  </div>

</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'
export default {
  computed:{ 
    smallFile:function(){ 
      var str=this.informdata.fileId_dictText||this.informdata.thumbnail_dictText||''
      if(str){
        var arr=[];
        var list=str.split(',');
        list.forEach(k=>{ 
          var txt=k.replace('temp/','')
          var strList=txt.split('_')
          txt=strList[0]+strList[1].replace(/[_0-9]{13,16}/g,'')//txt.replace(/[_0-9]{13,16}/g,'')
          arr.push({txt:txt,src:this.$fileAccessHttpUrl(k)})
        })
        return arr
      }
      return []
    },
    bigFile:function(){ 
      var str=this.informdata.uploadHref||''
      if(str){
        return str.split(',')
      }
      return []
    },
  },
  components: {
    tipcon,
    footPage,
  },
  data: function () {
    return {
      isDetail:false,
      tabindex: 0,//侧边
      sontabindex: 0,//子类
      tablist: [
        {name: "讲话", list: []},
        {name: "制度", list: []},
        {name: "知识", list: []},
      ],
      informdata: {},//详情
      id: "",
      msg: "",
      studyType: 1,//列表分类
      pageNo:1,
			total:8,
			pageSize:8,
      pageTip:true,
    };
  },

  mounted() {
    this.$onScrollT()

    if (this.$route.query.type) {
      this.studyType = this.$route.query.type;
      this.id = this.$route.query.id;
      if (this.studyType == 1) {
        this.tabindex = 0
      } else if (this.studyType == 2) {
        this.tabindex = 1
      } else if (this.studyType == 3) {
        this.tabindex = 2
      }
    }
    this.getStudyDatalist()
    if(this.id){ 
      this.isDetail=true;
      this.getStudyDataDetail()
    }
  },

  methods: {
    pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getStudyDatalist()
		},
    openUrl(url){
      window.open(url)
    },
    // 附件下载
    downLoadfile(item) {
      // window.open(this.$imgUrl + this.informdata.thumbnail_dictText)
      if(item.thumbnail_dictText||item.uploadType==1){ 
        if(item.uploadType==1){ 
          window.open(item.uploadHref)
        }else{ 
          window.open(this.$fileAccessHttpUrl(item.thumbnail_dictText))
        }
        
      }else{
        this.$message.success('没有附件')
      }
    },
    getStudyDatalist() {//列表
      this.$get(`web/info/studyData?pageSize=${this.pageSize}&pageNo=${this.pageNo}&studyType=${this.studyType}`).then(res => {
        if (res.success) {
          if (this.studyType == 1) {
            this.tablist[0].list = res.result.records
          } else if (this.studyType == 2) {
            this.tablist[1].list = res.result.records
          } else if (this.studyType == 3) {
            this.tablist[2].list = res.result.records
          }
          this.total = res.result.total
        }
      })
    },

    getStudyDataDetail() {//详情
      this.$get(`web/info/queryStudyDataById?id=${this.id}`).then(res => {
        if (res.success) {
          this.informdata = res.result
        }
      })
    },

    changetab(index) {//点击侧边栏分类
      this.isDetail=false;
      this.tabindex = index
      this.studyType = parseInt(this.tabindex) + 1
      this.pageNo=1;
      this.pageTip=false;
      this.$nextTick(()=>{ 
        this.pageTip=true;
      });
      this.getStudyDatalist()

    },

    changesontab(index) {//点击列表
      this.isDetail=true;
      this.sontabindex = index
      this.id = this.tablist[this.tabindex].list[index].id
      this.getStudyDataDetail()
    },

    qqshare() {
      window.open('http://connect.qq.com/widget/shareqq/index.html?url='
          + document.location.href + '?sharesource=qzone&title=少先队&pics=图片地址&summary=描述')
    },


  },


};
</script>

<style scoped="scoped" lang="scss">
.click-a{
  margin-bottom: 10px;
  padding: 0px 30px;
  box-sizing: border-box;
  color: #0000EE;
  cursor: pointer;
  a{
    text-decoration : none
  }
}

.w13 {
  overflow: hidden;
}
.pic_box {
  width: 100%;
  text-align: center;

  .pic {
    width: 80%;
    height: auto;
    margin: 10px auto;
  }
}

.download {
  margin-left: 30px;
  margin-bottom: 20px;
}

.learnmaterials {

  .content {
    display: flex;
    justify-content: center;

    .moddlecon {
      background-color: #FFFFFF;
      padding: 20px 50px 0px 50px;
			box-sizing: border-box;
      .carcon {
        display: flex;
        .l_c {
          .frame::-webkit-scrollbar {
            display: none;
          }

          .frame {
            width: 212px;
            background: #FFFFFF;
            border: 1px solid #E6E6E6;

            .signle {
              cursor: pointer;
              height: 50px;
              display: flex;
              align-items: center;
              border-bottom: 1px solid #E6E6E6;
              .imga {
                width: 10px;
                height: 12px;
                margin-left: 10px;
                margin-right: 40px;
              }
              .text_cur,.text{ 
                font-size: 18px;
                font-weight: 400;
              }
              .text_cur {
                color: #E61F26;
              }
              .text {
                color: #000000;
              }
            }
          }

        }

        .r_c {
          flex: 1;
          padding-bottom: 30px;
          // min-height: 600px;
          .listbox{
            width: calc(100% - 40px);
            margin-left: 40px;
            .signle{ 
              cursor: pointer;
							height: 80px;
              border-bottom: 1px dashed #ededed;
              font-size: 18px;
              font-weight: 400;
              .label{
                width: calc(100% - 150px);
                color: #333333;
              }
              .time{
                color: #999999;
              }
            }
            .signle:hover{ 
              .label,.time{
                color: #E61F26;
              }
              
            }
          }
          
          .shareto {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .imgwc,.imgqq{ 
              cursor: pointer;
              margin-left: 20px;
              height: 22px;
            }
            .imgwc {
              width: 26px;
            }
            .imgqq {
              width: 18px;
            }
          }

          .title {
            font-size: 30px;
            font-weight: bold;
            color: #333333;
            text-align: center;
            margin-top: 40px;
            min-height: 50px;
            line-height: 50px;
          }

          .timesource {
            font-size: 16px;
            color: #666666;
            text-align: center;
            height: 40px;
            line-height: 40px;
          }
          .msg {
            padding: 40px;
          }

        }

        .msg::-webkit-scrollbar ,.r_c::-webkit-scrollbar{
          display: none;
        }


      }


    }

  }


}

</style>

<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>
